const SensorHasMotion = (sensor) => {

  if(!sensor || !sensor.sensor_id) {
    return null;
  }

  const sensorId = sensor.sensor_id.toUpperCase();

  if(
    sensorId.startsWith("TS0000") ||
    sensorId.startsWith("LTE00") ||
    sensorId.startsWith("TS300") ||
    sensorId.startsWith("EX300") ||
    sensorId.startsWith("HC10")
  ) {
    return true;
  }

}

export default SensorHasMotion;
